import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const SET_MESSAGE_DUE = gql`
    mutation($input: SetMessageDueInput!) {
        setMessageDue(input: $input) {
            id
            parentMessageId
            referencedMessageId
            threadRootMessageId
            email { subject from receivedAt preview hasOriginalHtml }
            laneKind
            updatedAt
            reminderAt
            eventArtifactId
            event { startDate endDate startTime endTime timeZone location rawDate needsReview }
            reminderUpdatedAt
            reminderFiredAt
            reminderCancelledAt
            reminderVersion
            reminderDeliveryType
            reminderMessage
            automaticReminderNeedsReview
            dueAt
            dueTimezone
            dueKind

            dueSeriesEndAt
            alerts {
                id
                offsetMinutes
                deliveryType
                firedAt
            }
            folder {
                ...FolderCacheSafeFields
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;